module.exports = function (html) {
  return TextEditor.enrichHTML(html);
};
